import {Component} from '@angular/core';
import {IDataCellDisplayComponent} from '../../../../sdk/src/data-cell-display/idata-cell-display/idata-cell-display.component';
import {Skeleton} from 'primeng/skeleton';
import {ECpmCTaskStatusApiEnum} from '../../../../gen/cpm-c-api-ts/src/enums/c-customer/cpmc-task.api-enums';
import {PrimeNgImportsModule} from '../../../../sdk/src/prime-ng-imports';
import {CpmCServiceRequestApiModel} from '../../../../gen/cpm-c-api-ts/src/models/c-customer/cpmc-service-request.api-model';
import {ServiceRequestUtils} from '../../utils/service-request.utils';

/**
 * Task status data cell display component
 */
@Component({
    templateUrl: './service-request-status-data-cell-display.component.html',
    imports: [Skeleton, PrimeNgImportsModule]
})
export class ServiceRequestStatusDataCellDisplayComponent extends IDataCellDisplayComponent<
    CpmCServiceRequestApiModel,
    unknown
> {
    protected readonly ServiceRequestUtils = ServiceRequestUtils;

    // ===============================================================
    // ===============================================================

    protected _serviceRequest?: CpmCServiceRequestApiModel;
    protected _isWaitingForInput = false;
    protected _status?: ECpmCTaskStatusApiEnum;

    // ===============================================================
    // ===============================================================
    /**
     * On refresh (Error handling and refresh is done in the parent)
     */
    protected override async onRefresh(): Promise<void> {
        if (this.displayType !== 'table')
            throw new Error('Only table is supported for ServiceRequestStatusDataCellDisplayComponent');

        this._serviceRequest = this.row as CpmCServiceRequestApiModel;

        if (this._serviceRequest) {
            const result = ServiceRequestUtils.getStatus(this._serviceRequest);

            this._status = result.status;
            this._isWaitingForInput = result.waitingForInput;
        }
    }
}
